import GiftCardCWHCPrint from "./giftCardCWHCPrinter";
import Axios from "axios";
import CWOpenDrawer from "./CWOpenDrawer";
import printToken from "./printTokens";
import CWKOTPrinter from "./CWKotPrinter";
import { getOAuthHeaders } from "../../constants/oAuthValidation";

const CWHCPrint = (printData, PStatus) => {
  let receiptData = { ...printData };
  console.log("CWHCPrint - Initial Receipt Data:", receiptData);
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;
  receiptData.time = receiptData.orderTime ? receiptData.orderTime.split(" ").pop() : "";
  const disableAggregatorKOTPrint = process.env.REACT_APP_DISABLE_AGGREGATOR_KOT_PRINT === "true";

  receiptData.items = (receiptData.items || []).filter((item) => {
    return !(item.nettotal === 0 && item.unitTax === 0 && item.netStd === 0 && item.type !== "S" && item?.itemType !== "TGD");
  });
  receiptData.items = (receiptData.items || []).filter((item) => {
    return item?.orderStatus !== "CL";
  });
  receiptData.items = (receiptData.items || []).filter((item) => {
    return item?.productSegment !== "BG";
  });
  receiptData.items = (receiptData.items || []).map((item, index) => {
    item.sno = index + 1;
    return item;
  });

  receiptData.total = Number((receiptData.total + Number(receiptData.overPayedAmount || 0)).toFixed(pricePrecision ?? 2));
  receiptData.totalStd = Number((receiptData.totalStd + Number(receiptData.overPayedAmount || 0)).toFixed(pricePrecision ?? 2));

  const overPayed = Number(receiptData.overPayedAmount || 0);

  receiptData.payments = receiptData.payments.map((payment) => {
    let amount = Number(payment.amount);

    // Cash payment → apply rounding
    if (payment.roundOffForPos === "Y" && payment.integratedPayment === false) {
      amount = Number((amount + overPayed).toFixed(pricePrecision ?? 2));
    } else {
      // Non-cash → just fix precision
      amount = Number(amount.toFixed(pricePrecision ?? 2));
    }

    return {
      ...payment,
      amount,
    };
  });

  const formatExactDateTime = (dateStr) => {
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");
    let [hours, minutes, seconds] = timePart.split(":");

    hours = Number(hours);
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert 0 -> 12

    return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  console.log("Receipt Data after processing:", receiptData?.deliveryDate);
  if (receiptData?.deliveryDate) {
    receiptData.deliveryDate = formatExactDateTime(receiptData?.deliveryDate);
  }

  const currentDate = new Date().toISOString().split("T")[0];
  const storedTokenData = localStorage.getItem("tokenData") ? JSON.parse(localStorage.getItem("tokenData")) : {};
  const lastDate = storedTokenData.date || "";
  let tokenCounter = storedTokenData[lastDate] || 0;

  if (lastDate !== currentDate) {
    tokenCounter = 0; // Reset token counter if date changes
  }

  // Initialize vendors as an array
  const vendors = [];

  // Group items by productionCenter only for items with a valid productionCenterId
  const productionCenters = {};
  // (receiptData.items || []).forEach((item, index) => {
  //   const productionCenter = item.productionCenter || "Unknown P C"; // Fallback if productionCenter is empty
  //   const productionCenterId = item.productionCenterId || "";
  //   const printerId = item?.printerId ? item.printerId : "";

  //   // Only process items with a valid productionCenterId
  //   if (productionCenterId && !receiptData?.externalId) {
  //     if (!productionCenters[productionCenter]) {
  //       tokenCounter++; // Increment tokenCounter for each new productionCenter
  //       const newToken = `T-${tokenCounter}`;
  //       productionCenters[productionCenter] = {
  //         productionCenter: productionCenter,
  //         productionCenterId: productionCenterId,
  //         token: newToken,
  //         items: [],
  //         subTotal: 0,
  //         printerId: printerId,
  //       };
  //       vendors.push(productionCenters[productionCenter]);
  //     }
  //     productionCenters[productionCenter].items.push({
  //       name: item.name || "",
  //       weight: item.weight || 1, // Quantity
  //       grossunit: parseFloat(item.grossunit || item.salePrice || 0).toFixed(2), // Price per unit
  //       linegross: parseFloat(item.linegross || item.nettotal || 0).toFixed(2), // Total per item
  //       addons: item.selectedAddons || [],
  //       preparationTime: item?.preparationTime || null,
  //       notes: item?.notes || null,
  //     });
  //     productionCenters[productionCenter].subTotal += parseFloat(item.linegross || 0);
  //   } else if (receiptData?.externalId && !disableAggregatorKOTPrint) {
  //     CWKOTPrinter(receiptData, true);
  //   }
  // });
  let hasProductionCenter = false;

  (receiptData.items || []).forEach((item) => {
    const productionCenter = item.productionCenter || "Unknown P C";
    const productionCenterId = item.productionCenterId || "";
    const printerId = item?.printerId || "";

    if (productionCenterId && !receiptData?.externalId) {
      hasProductionCenter = true;

      if (!productionCenters[productionCenter]) {
        tokenCounter++;
        const newToken = `T-${tokenCounter}`;

        productionCenters[productionCenter] = {
          productionCenter,
          productionCenterId,
          token: newToken,
          items: [],
          subTotal: 0,
          printerId,
        };

        vendors.push(productionCenters[productionCenter]);
      }

      productionCenters[productionCenter].items.push({
        name: item.name || "",
        weight: item.weight || 1,
        grossunit: parseFloat(item.grossunit || item.salePrice || 0).toFixed(2),
        linegross: parseFloat(item.linegross || item.nettotal || 0).toFixed(2),
        addons: item.selectedAddons || [],
        preparationTime: item?.preparationTime || null,
        notes: item?.notes || null,
      });

      productionCenters[productionCenter].subTotal += parseFloat(item.linegross || 0);
    }
  });

  // 🔥 PRINT LOGIC (OUTSIDE LOOP)

  // Case 1: Aggregator
  if (receiptData?.externalId && !disableAggregatorKOTPrint) {
    CWKOTPrinter(receiptData, true);
  }

  // // Case 2: No Production Centers → Single Print
  // else if (!hasProductionCenter) {
  //   CWKOTPrinter(receiptData, false);
  // }

  // Case 3: Production Centers → Multiple Prints (1 per PC)
  // else {
  //   vendors.forEach((vendor) => {
  //     CWKOTPrinter(vendor, false);
  //   });
  // }

  // Store updated token data only if at least one item was processed (i.e., vendors exist)
  if (vendors.length > 0) {
    storedTokenData.date = currentDate;
    storedTokenData[currentDate] = tokenCounter; // Update for the current date
    localStorage.setItem("tokenData", JSON.stringify(storedTokenData));
  }
  receiptData.vendorsCount = vendors.length.toString();
  // Add vendors to receiptData
  receiptData.vendors = vendors;
  receiptData.token = `T-${tokenCounter}`;
  // Set orderDate from cart data or current date
  receiptData.orderDate = printData.orderDate || new Date().toISOString().split("T")[0];

  // Print KOT only if there are vendors (i.e., items with valid production centers)
  if (posConfig?.enableKOTPrint === "Y" && receiptData?.saleType?.enableKot === "Y" && vendors.length > 0 && tillData?.tillAccess?.cwrTill?.kotPrintTemplate?.xmlcode2) {
    // Call tokens.js for each vendor with the same bill token
    vendors.forEach((vendor) => {
      printToken(vendor, receiptData);
    });
  }

  const sales_receipt_copies = posConfig?.sales_receipt_copies && posConfig?.sales_receipt_copies !== null ? posConfig?.sales_receipt_copies : 0;
  const return_receipt_copies = posConfig?.return_receipt_copies && posConfig?.return_receipt_copies !== null ? posConfig?.return_receipt_copies : 0;
  const layaway_receipt_copies = posConfig?.layaway_receipt_copies && posConfig?.layaway_receipt_copies !== null ? posConfig?.layaway_receipt_copies : 0;
  const layaway_paid_receipt_copies = posConfig?.layaway_paid_receipt_copies && posConfig?.layaway_paid_receipt_copies !== null ? posConfig?.layaway_paid_receipt_copies : 0;
  const loyalty_receipt_copies = posConfig?.loyalty_receipt_copies && posConfig?.loyalty_receipt_copies !== null ? posConfig?.loyalty_receipt_copies : 0;
  const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
  let isloyalty =
    (receiptData.payments && receiptData.payments.some((payment) => payment.isloyalty)) ||
    (receiptData?.paymentData && receiptData?.paymentData.some((payment) => payment?.isloyalty));
  const templateId = localStorage.getItem("selectedPrintTemplateId") || null;
  let docTypeTemplateId = null;
  let printTemplate = null;
  if (templateId) {
    const printTemplates = tillData?.tillAccess?.cwrTill?.printTemplates ? JSON.parse(tillData?.tillAccess?.cwrTill?.printTemplates) : [];
    printTemplate = printTemplates?.find((template) => template?.cwr_printtemplate_id === templateId)?.xmlcode2;
    docTypeTemplateId = printTemplates?.find((template) => template?.cwr_printtemplate_id === templateId)?.cs_doctype_template_id;
  }
  if (docTypeTemplateId !== null) {
    const isDuplicate = PStatus === "Duplicate Copy";
    const printCount = isDuplicate ? 1 : sales_receipt_copies;
    const formData = new FormData();
    formData.append("windowId", "7004");
    formData.append("tabId", "270EED9D0E7F4C43B227FEDC44C5858F");
    formData.append("recordId", receiptData?.sOrderID || "");
    formData.append("type", "Print-Template");
    formData.append("printTemplateId", docTypeTemplateId);

    const { access_token } = getOAuthHeaders() || {};

    Axios.post(`${process.env.REACT_APP_downloadPrintTemplatesUrl}`, formData, {
      headers: {
        Authorization: access_token,
      },
    })
      .then((res) => {
        const fileUrl = res?.data;

        if (!fileUrl) return;

        let successfulPrints = 0;

        // ✅ SAME LOGIC AS sales_receipt_copies
        for (let i = 0; i < printCount; i++) {
          Axios.post(`${printerURL}printer`, fileUrl, {
            headers: {
              "Content-Type": "text/plain",
            },
          })
            .then(() => {
              console.log("Print success!");
              successfulPrints++;

              if (successfulPrints === sales_receipt_copies) {
                // ✅ Open cash drawer
                if (receiptData.layAway === "N" && !PStatus && !receiptData.draftFlag && receiptData?.payments?.some((p) => p?.name === "Cash")) {
                  CWOpenDrawer();
                }

                // ✅ Gift card printing
                receiptData.items.forEach((data) => {
                  if (receiptData.isReturn && data?.giftCardType === "DIG") {
                    GiftCardCWHCPrint(data, "Credit Note");
                  } else if (data?.giftCardType === "DIG") {
                    GiftCardCWHCPrint(data, "Gift Card");
                  }
                });
              }
            })
            .catch((err) => {
              console.error("Print failed!", err);
            });
        }
        localStorage.removeItem("selectedPrintTemplateId");
      })
      .catch((err) => {
        console.error("Error in print flow:", err);
      });
    localStorage.removeItem("selectedPrintTemplateId");
    return;
  }
  let receiptTemplate = printTemplate
    ? JSON.parse(printTemplate)
    : tillData.tillAccess.cwrTill.printTemplate.xmlcode2
      ? JSON.parse(tillData.tillAccess.cwrTill.printTemplate.xmlcode2)
      : {};
  const groupedItems = {};
  (receiptData.items || []).forEach((item) => {
    const key = item.tax && item.tax.rate !== undefined && item.tax.rate !== null ? item.tax.rate : item.taxRate || "0"; // Fallback to "0" if no tax rate
    if (!groupedItems[key]) {
      groupedItems[key] = [];
    }
    groupedItems[key].push(item);
  });

  const groupedItemsByTaxRate = [];
  for (const taxRate in groupedItems) {
    const totalTaxAmount = groupedItems[taxRate].reduce(
      (total, item) =>
        total +
        (item.tax && item.tax.rate !== undefined && item.tax.rate !== null
          ? parseFloat(parseFloat(item.linetax || 0).toFixed(2))
          : parseFloat(parseFloat(item.taxAmount || 0).toFixed(2))),
      0
    );
    const totalNetTotal = groupedItems[taxRate].reduce(
      (total, item) =>
        total +
        (item.tax && item.tax.rate !== undefined && item.tax.rate !== null
          ? parseFloat(parseFloat(item.linegross || 0).toFixed(2))
          : parseFloat(parseFloat(item.nettotal || 0).toFixed(2))),
      0
    );
    groupedItemsByTaxRate.push({
      taxRate: taxRate,
      totalLinenet: (totalNetTotal - totalTaxAmount).toFixed(2),
      totalLinetax: totalTaxAmount.toFixed(2),
      totalLinegross: totalNetTotal.toFixed(2),
    });
  }
  // Extract values from customer.metaData
  // Extract GST No
  let gstNo = "";

  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const gstObj = receiptData.customer.metaData.find((item) => item.key === "Gst No" || item.key === "G ST No");
    gstNo = gstObj?.value || "";
  }

  // Extract Address Line1
  let addressLine1 = "";

  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const b2bFlag = localStorage.getItem("isB2bEnabled") === "true";
    const customerConfig = localStorage.getItem("customerConfigs") ? JSON.parse(localStorage.getItem("customerConfigs")) : [];
    const customerConfigData = customerConfig?.length > 0 ? JSON.parse(customerConfig[0]?.configuration) : {};
    const retailCustomerGroups = customerConfigData?.fieldGroups || [];
    if (b2bFlag && retailCustomerGroups.length > 0) {
      const groupId = retailCustomerGroups?.find((g) => g.name === "Invoicing Address")?.id;
      const addressObj = receiptData.customer.metaData.find((item) => item.key === groupId)?.value
        ? JSON.parse(receiptData.customer.metaData.find((item) => item.key === groupId)?.value)
        : null;
      addressLine1 = addressObj?.line1 || "";
    } else if (retailCustomerGroups.length > 0) {
      const groupId = retailCustomerGroups?.find((g) => g.name === "Address")?.id;
      const addressObj = receiptData.customer.metaData.find((item) => item.key === groupId)?.value
        ? JSON.parse(receiptData.customer.metaData.find((item) => item.key === groupId)?.value)
        : null;
      addressLine1 = addressObj?.line1 || "";
    } else {
      // Debug log to check the structure of metaData
      const addressObj = receiptData.customer.metaData.find((item) => item.key === "Line1");
      addressLine1 = addressObj?.value || "";
    }
  }

  let state = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const stateObj = receiptData.customer.metaData.find((item) => item.key === "State");
    const stateId = stateObj?.value || "";
    const statesData = JSON.parse(localStorage.getItem("statesData")) || [];
    state = statesData.find((item) => item.RecordID === stateId)?.Name || "";
  }

  let country = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const countryObj = receiptData.customer.metaData.find((item) => item.key === "Country");
    const countryId = countryObj?.value || "";
    const countriesData = JSON.parse(localStorage.getItem("countriesData")) || [];
    country = countriesData.find((item) => item.RecordID === countryId)?.Name || "";
  }

  // Attach to receiptData.customer
  receiptData.customer = {
    ...receiptData.customer,
    gstNo: gstNo,
    addressLine1: addressLine1,
    country: country,
    state: state,
  };

  // Attach to customer object
  receiptData.customer = {
    ...receiptData.customer,
    gstNo: gstNo,
    addressLine1: addressLine1,
    country: country,
    state: state,
  };

  if (Array.isArray(receiptData.items)) {
    receiptData.items = receiptData.items.map((item, index) => ({
      ...item,
      index,
      ediCode: Array.isArray(item.uomData) && item.uomData.length > 0 ? item.uomData[0]?.ediCode || "" : "",
    }));
  }

  console.log("isPreOrderPage:", receiptData.isPreOrderPage, window.location.pathname.includes("/preorder"), typeof receiptData.isPreOrderPage);

  // Merge groupedItemsByTaxRate and PStatus into receiptData
  const updatedReceiptData = {
    ...receiptData,
    // groupedItemsByTaxRate,
    PStatus,
    previousCashBalance: receiptData.customer?.retlLoyaltyBalance + receiptData?.redemptionPoints,
  };
  updatedReceiptData.isPreOrderPage = window.location.pathname.includes("/preorder") || receiptData.isPreOrderPage === true;

  const processedReceipt = processReceiptTemplate(receiptTemplate, updatedReceiptData);
  let printReciptData = receiptData;
  let decodedData = JSON.stringify(processedReceipt, null, 2);
  if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    printReciptData.isReturn &&
    printReciptData.layAway === "N" &&
    return_receipt_copies !== 0 &&
    !PStatus &&
    !isloyalty
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < return_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.log("Print success !");
          successfulPrints++;
          if (successfulPrints === return_receipt_copies) {
            if (printReciptData.layAway === "N" && !PStatus && !printReciptData.draftFlag && printReciptData?.payments?.some((payment) => payment?.name === "Cash")) {
              CWOpenDrawer();
            }
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.log("XML print failed !", response);
        });
    }
  } else if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    !printReciptData.isReturn &&
    printReciptData.layAway === "N" &&
    sales_receipt_copies !== 0 &&
    !PStatus &&
    !isloyalty
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < sales_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.log("Print success !");
          localStorage.removeItem("selectedPrintTemplateId");
          successfulPrints++;
          if (successfulPrints === sales_receipt_copies) {
            if (printReciptData.layAway === "N" && !PStatus && !printReciptData.draftFlag && printReciptData?.payments?.some((payment) => payment?.name === "Cash")) {
              CWOpenDrawer();
            }
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.log("Print failed !", response);
          localStorage.removeItem("selectedPrintTemplateId");
        });
    }
  } else if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    printReciptData.layAway === "Y" &&
    printReciptData.paid === 0 &&
    layaway_receipt_copies !== 0 &&
    !printReciptData?.externalId &&
    !PStatus
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < layaway_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.log("Print success !");
          successfulPrints++;
          if (successfulPrints === layaway_receipt_copies) {
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.log("Print failed !", response);
        });
    }
  } else if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    printReciptData.layAway === "Y" &&
    printReciptData.paid !== 0 &&
    layaway_paid_receipt_copies !== 0 &&
    !printReciptData?.externalId &&
    !PStatus
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < layaway_paid_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.log("Print success !");
          successfulPrints++;
          if (successfulPrints === layaway_paid_receipt_copies) {
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.log("Print failed !", response);
        });
    }
  } else if (printReciptData.items.length > 0 && !printReciptData.draftFlag && !PStatus && printReciptData.layAway === "N" && loyalty_receipt_copies !== 0 && isloyalty) {
    let successfulPrints = 0;

    // Loop for printing loyalty receipt copies
    for (let i = 0; i < loyalty_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.log("Print success!");
          successfulPrints++;

          // Execute logic after all prints are successful
          if (successfulPrints === loyalty_receipt_copies) {
            if (printReciptData.layAway === "N" && !PStatus && !printReciptData.draftFlag && printReciptData?.payments?.some((payment) => payment?.name === "Cash")) {
              CWOpenDrawer();
            }
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((error) => {
          console.error("Print failed!", error);
        });
    }
  } else {
    Axios.post(`${printerURL}printer`, decodedData, {
      headers: {
        "Content-Type": "text/plain",
      },
    })
      .then(() => {
        console.log("Print success !");
        if (
          (printReciptData.layAway === "N" || (printReciptData.layAway === "Y" && printReciptData.paid !== 0)) &&
          !PStatus &&
          !printReciptData.draftFlag &&
          printReciptData?.payments?.some((payment) => payment?.name === "Cash")
        ) {
          CWOpenDrawer();
        }
        printReciptData.items.forEach((data) => {
          if (printReciptData.isReturn && data?.giftCardType === "DIG") {
            GiftCardCWHCPrint(data, "Credit Note");
          } else if (data?.giftCardType === "DIG") {
            GiftCardCWHCPrint(data, "Gift Card");
          }
        });
      })
      .catch((response) => {
        console.log("Print failed !", response);
      });
  }
  return processedReceipt;
};

const processReceiptTemplate = (template, data) => {
  const processedTemplate = JSON.parse(JSON.stringify(template));

  processedTemplate.elements = processedTemplate.elements.flatMap((element) => {
    // Process text elements
    if (element.type === "text" && element.content && typeof element.content === "string") {
      element.content = replacePlaceholders(element.content, data);
    }

    // Process table elements
    if (element.type === "table" && element.data && typeof element.data === "string" && element.dataMapping) {
      const dataPath = element.data.replace(/{{|}}/g, ""); // e.g., "items"
      const tableData = getDeepValue(data, dataPath) || [];

      const columnKeys = element.columns.map((col, idx) => ({
        key: Object.keys(element.dataMapping).find((k) => element.dataMapping[k] === Object.values(element.dataMapping)[idx]),
        width: col.width,
        alignment: col.alignment,
        format: col.format,
        trim: col?.trim === true,
      }));

      element.data = (Array.isArray(tableData) ? tableData : [])
        .flatMap((item) => {
          // Skip main row for items with children (handled by GroupedItems)
          const hasChildren = item[element.GroupedItems?.field] && Array.isArray(item[element.GroupedItems?.field]) && item[element.GroupedItems?.field].length > 0;
          const mainRow = !hasChildren
            ? {
                ...Object.keys(element.dataMapping).reduce((row, targetKey) => {
                  const colMeta = columnKeys.find((ck) => ck.key === targetKey);
                  row[targetKey] = formatValue(item[element.dataMapping[targetKey]], colMeta?.format, colMeta);
                  return row;
                }, {}),
              }
            : null;

          // Extra rows based on extraRows configuration
          const extraRows = (element.extraRows || []).flatMap((extra) => {
            // Handle fields array (e.g., discount)
            if (extra.fields && Array.isArray(extra.fields)) {
              const allHidden = extra.fields.every((fieldConfig) => {
                const value = item[fieldConfig.field];
                return fieldConfig.hideIfZeroOrEmpty && (value === null || value === undefined || value === 0);
              });

              if (allHidden) {
                return []; // Skip if all fields are hidden
              }

              const extraRow = {};
              let hasContent = false;
              columnKeys.forEach((col) => {
                const fieldConfig = extra.fields.find((f) => f.column === col.key);
                if (fieldConfig) {
                  const value = item[fieldConfig.field];
                  const shouldHide = fieldConfig.hideIfZeroOrEmpty && (value === null || value === undefined || value === 0);
                  if (!shouldHide && value !== null && value !== undefined) {
                    extraRow[col.key] = (fieldConfig.prefix || "") + (fieldConfig.format || fieldConfig.trim ? formatValue(value, fieldConfig?.format, fieldConfig) : value);
                    hasContent = true;
                  } else {
                    extraRow[col.key] = "";
                  }
                } else {
                  extraRow[col.key] = "";
                }
              });

              return hasContent ? [extraRow] : [];
            }

            // Handle single field (e.g., addons with loop or name2)
            const value = item[extra.field];
            if (extra.loop) {
              const loopData = value || [];
              if (!Array.isArray(loopData)) {
                return []; // Skip if not an array
              }

              return loopData.flatMap((loopItem) => {
                const subValue = loopItem[extra.subField];
                const shouldHide = extra.hideIfZeroOrEmpty && (subValue === null || subValue === undefined || subValue === "");
                if (!shouldHide && subValue !== null && subValue !== undefined) {
                  const extraRow = {};
                  columnKeys.forEach((col) => {
                    extraRow[col.key] = col.key === extra.column ? (extra.prefix || "") + subValue : "";
                    if ((extra.format || extra.trim) && col.key === extra.column) {
                      extraRow[col.key] = formatValue(subValue, extra?.format, extra);
                    }
                  });
                  return [extraRow];
                }
                return [];
              });
            }

            // Handle non-looped single field
            const shouldHide = extra.hideIfZeroOrEmpty && (value === null || value === undefined || value === 0);
            if (!shouldHide && value !== null && value !== undefined) {
              const extraRow = {};
              columnKeys.forEach((col) => {
                extraRow[col.key] = col.key === extra.column ? value : "";
                if ((extra.format || extra.trim) && col.key === extra.column) {
                  extraRow[col.key] = formatValue(value, extra?.format, extra);
                }
              });
              return [extraRow];
            }
            return [];
          });

          // Process GroupedItems
          const groupedRows = [];
          if (element.GroupedItems) {
            const groupedConfig = element.GroupedItems;
            const value = item[groupedConfig.field];
            if (groupedConfig.loop && Array.isArray(value) && value.length > 0) {
              // Add bold parent row if specified
              if (groupedConfig.boldParent && item[groupedConfig.subField]) {
                const parentRow = {};
                columnKeys.forEach((col) => {
                  parentRow[col.key] = col.key === Object.keys(element.dataMapping)[0] ? item[groupedConfig.subField] : "";
                });
                parentRow.style = ["bold"];
                groupedRows.push(parentRow);
              }

              // Add child rows
              value.forEach((loopItem) => {
                const subValue = loopItem[groupedConfig.subField];
                const shouldHide = groupedConfig.hideIfZeroOrEmpty && (subValue === null || subValue === undefined || subValue === "");
                if (!shouldHide && subValue !== null && subValue !== undefined) {
                  const groupedRow = {};
                  columnKeys.forEach((col) => {
                    if (groupedConfig.dataMapping && groupedConfig.dataMapping[col.key]) {
                      groupedRow[col.key] = formatValue(
                        loopItem[groupedConfig.dataMapping[col.key]],
                        col.format || (groupedConfig.format && col.key === groupedConfig.column ? groupedConfig.format : undefined),
                        col
                      );
                    } else {
                      groupedRow[col.key] = col.key === groupedConfig.column ? (groupedConfig.prefix || "") + subValue : "";
                    }
                  });
                  groupedRows.push(groupedRow);
                }
              });
            }
          }

          return mainRow ? [mainRow, ...extraRows, ...groupedRows] : [...extraRows, ...groupedRows];
        })
        .filter((row) => {
          // Final filter to remove any fully empty rows
          return Object.values(row).some((val) => val !== "" && val !== null && val !== undefined);
        });
    }

    // Process barcode elements
    if (element.type === "barcode" && element.content) {
      element.content = replacePlaceholders(element.content, data);
    }

    // Process QR elements
    if (element.type === "qrcode" && element.content) {
      element.content = replacePlaceholders(element.content, data);
    }

    // Process loop elements
    if (element.type === "loop" && element.data && typeof element.data === "string") {
      const loopDataPath = element.data.replace(/{{|}}/g, "");
      const loopData = getDeepValue(data, loopDataPath) || [];
      if (Array.isArray(loopData)) {
        return loopData.flatMap((loopItem) => {
          return element.elements.map((loopElement) => {
            const newElement = JSON.parse(JSON.stringify(loopElement));
            if (newElement.type === "text" && newElement.content && typeof newElement.content === "string") {
              newElement.content = replacePlaceholders(newElement.content, loopItem);
            }
            if (newElement.type === "table" && newElement.data && typeof newElement.data === "string" && newElement.dataMapping) {
              const tableData = getDeepValue(loopItem, newElement.data.replace(/{{|}}/g, "")) || [];
              const columnKeys = newElement.columns.map((col, idx) => ({
                key: Object.keys(newElement.dataMapping).find((k) => newElement.dataMapping[k] === Object.values(newElement.dataMapping)[idx]),
                width: col.width,
                alignment: col.alignment,
                format: col.format,
              }));

              newElement.data = tableData
                .flatMap((item) => {
                  const mainRow = {};
                  for (const targetKey in newElement.dataMapping) {
                    mainRow[targetKey] = formatValue(
                      item[newElement.dataMapping[targetKey]],
                      columnKeys.find((ck) => ck.key === targetKey)?.format,
                      columnKeys.find((ck) => ck.key === targetKey)
                    );
                  }
                  return [mainRow];
                })
                .filter((row) => Object.values(row).some((val) => val !== "" && val !== null && val !== undefined));
            }
            return newElement;
          });
        });
      }
    }

    // Process conditional elements
    if (element.type === "conditional") {
      const condition = element.condition.replace(/{{|}}/g, "").trim();
      try {
        const conditionResult = new Function(...Object.keys(data), `return ${condition};`)(...Object.values(data));
        if (conditionResult) {
          return element.elements.map((el) => processReceiptTemplate({ elements: [el] }, data).elements).flat();
        }
        return [];
      } catch (error) {
        console.error("Error evaluating condition:", condition, error);
        return [];
      }
    }

    return element;
  });

  return processedTemplate;
};
const replacePlaceholders = (text, data) => {
  return text.replace(/{{([^}]+)}}/g, (match, placeholder) => {
    // Handle currentDateTime
    // if (placeholder === "currentDateTime") {
    //   return new Date().toLocaleString();
    // }
    if (placeholder === "currentDateTime") {
      const d = new Date();

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12

      return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
    }

    // Get the value from the data object (for simple placeholders like {{tax}})
    let value = getDeepValue(data, placeholder);

    // Format numbers correctly for simple placeholders
    if (typeof value === "number" && !isNaN(value)) {
      return value === 0 ? "0.00" : value.toFixed(2);
    }

    // Handle array sum
    if (placeholder.startsWith("sum ")) {
      try {
        const [_, path] = placeholder.split("sum ").map((s) => s.trim()); // Split "sum" and the path
        const array = getDeepValue(data, path.split(".")[0]); // Get the array (e.g., items)
        const key = path.split(".")[1]; // Get the key (e.g., linegross)

        if (Array.isArray(array) && key) {
          const sum = array.reduce((total, item) => {
            const val = typeof item[key] === "string" ? parseFloat(item[key]) : item[key];
            return total + (typeof val === "number" && !isNaN(val) ? val : 0);
          }, 0);
          return sum === 0 ? "0.00" : sum.toFixed(2);
        }
        return "0.00"; // Fallback if array or key is invalid
      } catch (error) {
        console.error("Error summing array key:", placeholder, error);
        return "0.00";
      }
    }

    // Handle expressions like {{tax / 2}}
    if (placeholder.match(/[+\-*/]/)) {
      try {
        const resolvedExpression = placeholder.replace(/\b[a-zA-Z_]\w*\b/g, (varName) => {
          const val = getDeepValue(data, varName);
          // Convert to number if string, default to 0 if invalid
          const numVal = typeof val === "string" ? parseFloat(val) : val;
          return typeof numVal === "number" && !isNaN(numVal) ? numVal : 0;
        });
        const result = eval(resolvedExpression);
        // Handle Infinity or NaN
        if (!isFinite(result)) {
          return "0.00";
        }
        return result === 0 ? "0.00" : result.toFixed(2);
      } catch (error) {
        console.error("Error evaluating expression:", placeholder, error);
        return "0.00";
      }
    }

    // Return original value or empty string if undefined/null
    return value !== null && value !== undefined ? value : "";
  });
};

const getDeepValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), obj);
};

const formatValue = (value, format, column) => {
  let formatted = value;

  if (format && format === "currency" && typeof value === "number") {
    formatted = value.toFixed(2);
  }

  if (column?.trim && typeof formatted === "string" && column?.width) {
    formatted = formatted.slice(0, column.width);
  }

  return formatted;
};

export default CWHCPrint;
